import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Star, ExternalLink } from "lucide-react";

const Stars = ({ n }) => (
  <span className="inline-flex" aria-label={`${n} étoiles`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`w-3.5 h-3.5 ${i <= Math.round(n || 0) ? "fill-rose-brand text-rose-brand" : "text-border"}`} />)}
  </span>
);

export function GoogleReviews({ compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/google-reviews").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data || !data.rating) return null;
  const shown = compact ? data.reviews.slice(0, 3) : data.reviews;
  return (
    <section className="rounded-2xl bg-white border border-border p-5" data-testid="google-reviews">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Avis Google</p>
          <p className="font-serif text-2xl text-olive flex items-center gap-2 mt-1" data-testid="google-rating">
            {String(data.rating).replace(".", ",")} <Stars n={data.rating} /> <span className="text-sm text-muted-foreground font-sans">· {data.count} avis · {data.name}</span>
          </p>
        </div>
        {data.maps_url && <a href={data.maps_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm text-rose-brand font-semibold hover:underline"><ExternalLink className="w-4 h-4" /> Voir sur Google</a>}
      </div>
      <div className={`grid grid-cols-1 ${compact ? "md:grid-cols-3" : "md:grid-cols-2"} gap-3 mt-4`}>
        {shown.map((r, i) => (
          <article key={i} className="rounded-xl bg-secondary/60 p-4 text-sm" data-testid="google-review">
            <div className="flex items-center gap-2">
              {r.photo ? <img src={r.photo} alt="" className="w-8 h-8 rounded-full" referrerPolicy="no-referrer" /> : <span className="w-8 h-8 rounded-full bg-olive text-white flex items-center justify-center text-xs font-bold">{(r.author || "?")[0]}</span>}
              <div className="min-w-0"><p className="font-semibold text-olive truncate">{r.author}</p><p className="text-xs text-muted-foreground">{r.when}</p></div>
              <span className="ml-auto"><Stars n={r.rating} /></span>
            </div>
            {r.text && <p className="mt-2 text-foreground leading-relaxed">{r.text}</p>}
          </article>
        ))}
      </div>
    </section>
  );
}
